<template>
  <div class="read-history-box">
    <NvHeader title="Viewed" />
    <NvBookGrid :books="books" />
  </div>
</template>

<script>
import { getReadHistory } from "@/service/api";
import NvBookGrid from "@/components/layout/NvBookGrid";
import NvHeader from "@/components/widget/NvHeader";

export default {
  components: {
    NvBookGrid,
    NvHeader
  },
  data() {
    return {
      books: [],
      fromPageName: ""
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    getReadHistoryList() {
      getReadHistory().then(res => {
        this.books = res;
      });
    }
  },
  mounted() {
    this.getReadHistoryList();
    window.$event("History_Show", { from: this.fromPageName });
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromPageName = from.meta.pageName;
    });
  }
};
</script>

<style lang="scss" scoped>
.read-history-box {
  .book-list {
    margin-top: 45px;
    display: flex;
    justify-content: center;
    .book-list-content {
      margin: 32px 16px;
      .book-box {
        padding: 0 5px;
        float: left;
        width: calc((100vw - 32px - 30px) / 3);
        margin-bottom: 16px;
        &.book-add-box {
          background: $bg-main;
          border-radius: 6px;
          height: 9rem;
          .icon-big {
            font-size: 50px;
            color: $fc-grey;
          }
        }
      }
    }
  }
}
</style>
